/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';

const appSelector = (state) => state.app;

export const appThemeSelector = createSelector(appSelector, (app) => app.siteTheme);
